var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewThresholdAmountIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.719727,
    y: 0.824219,
    width: 69.5197,
    height: 69.5197,
    rx: 5,
    fill: "#EDF2FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.9337 32H40.067C41.5605 32 42.3072 32 42.8776 32.2906C43.3794 32.5463 43.7873 32.9543 44.043 33.456C44.3337 34.0265 44.3337 34.7732 44.3337 36.2667V43.7333C44.3337 45.2268 44.3337 45.9735 44.043 46.544C43.7873 47.0457 43.3794 47.4537 42.8776 47.7094C42.3072 48 41.5605 48 40.067 48H29.9337C28.4402 48 27.6934 48 27.123 47.7094C26.6213 47.4537 26.2133 47.0457 25.9576 46.544C25.667 45.9735 25.667 45.2268 25.667 43.7333V36.2667C25.667 34.7732 25.667 34.0265 25.9576 33.456C26.2133 32.9543 26.6213 32.5463 27.123 32.2906C27.6934 32 28.4402 32 29.9337 32Z",
    fill: "#C3D2FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.667 32V29.3333C29.667 26.3878 32.0548 24 35.0003 24C37.9458 24 40.3337 26.3878 40.3337 29.3333V32M29.9337 48H40.067C41.5605 48 42.3072 48 42.8776 47.7094C43.3794 47.4537 43.7873 47.0457 44.043 46.544C44.3337 45.9735 44.3337 45.2268 44.3337 43.7333V36.2667C44.3337 34.7732 44.3337 34.0265 44.043 33.456C43.7873 32.9543 43.3794 32.5463 42.8776 32.2906C42.3072 32 41.5605 32 40.067 32H29.9337C28.4402 32 27.6934 32 27.123 32.2906C26.6213 32.5463 26.2133 32.9543 25.9576 33.456C25.667 34.0265 25.667 34.7732 25.667 36.2667V43.7333C25.667 45.2268 25.667 45.9735 25.9576 46.544C26.2133 47.0457 26.6213 47.4537 27.123 47.7094C27.6934 48 28.4402 48 29.9337 48Z",
    stroke: "#2828F0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewThresholdAmountIcon);
export default __webpack_public_path__ + "static/media/newThresholdAmountIcon.1aa8f6ca2fc028aca929bf579388ffc4.svg";
export { ForwardRef as ReactComponent };